import { render } from "./McustomerGroupUpdate.vue?vue&type=template&id=c0274bdc&scoped=true"
import script from "./McustomerGroupUpdate.vue?vue&type=script&lang=js"
export * from "./McustomerGroupUpdate.vue?vue&type=script&lang=js"

import "./McustomerGroupUpdate.vue?vue&type=style&index=0&id=c0274bdc&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0274bdc"]])

export default __exports__